import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { isNull } from "../../helpers/util-methods";

export const MessagePromptBox = ({ closeMessageBox }) => {
    const [names, setNames] = useState('');
    const [message, setMessage] = useState('');

    const handleSendMessage = () => {
        if (isNull(names) || isNull(message)) {
            alert('Bitte geben Sie Ihren Namen und eine Nachricht an.');
            return;
        }
            window.location.href = `https://wa.me/+4917622006681?text=Hallo, ich bin ${names}. ${message}`;
    }

    return (
        <div className="dark-bg flx-col c-al c-jt">

            <form
                className="message-prompt-form flx-v"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSendMessage();
                }}
            >
                <div className="close-button-box flx-rw c-al e-jt">
                    <button 
                        className="close-button tr-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            closeMessageBox();
                        }}
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
                <div className="input-container flx-rw c-al">
                    <input
                        type="text"
                        className="names"
                        name="names"
                        onChange={(e) => {
                            e.preventDefault();
                            setNames(e.target.value);
                        }}
                        placeholder="eure Namen"
                    />
                </div>
                <div className="input-container">
                    <textarea
                        name="message"
                        id=""
                        className="wa-message"
                        placeholder="Geben Sie hier Ihre Nachricht ein."
                        onChange={(e) => {
                            e.preventDefault();
                            setMessage(e.target.value)
                        }}
                        cols={45}
                        rows={5}
                    />
                </div>
                <div className="send-button-box flx-rw c-al c-jt">
                    <button
                        className="wa-message-button"
                        onClick={(e) => {
                            e.preventDefault();
                            handleSendMessage();
                        }}
                    >
                        Schicken
                    </button>
                </div>
            </form>
        </div>
    )
}